import useBrazeStore from '../../store/useBrazeStore'

export const logVisitEvent = (appboy, eventName, eventProperties = null) => {
  if (appboy) {
    appboy.logCustomEvent(eventName, eventProperties)
  }
}

export const logApplyLesson = (appboy) => {
  if (appboy) {
    appboy.logCustomEvent('lesson_booked')
  }
}

export const logProductPageVisit = (appboy, productInfoName, productId) => {
  if (appboy) {
    console.log(`Log Product Page Visit: ${productId}`, productInfoName)
    appboy.getUser().setCustomUserAttribute('last_visited_product_name', productInfoName)
    appboy.logCustomEvent('product_visit', { id: productId, name: productInfoName })
  }
}

export const useLogB2BClick = () => {
  const appboy = useBrazeStore((state) => state.appboy)
  return () => {
    if (appboy) {
      appboy.logCustomEvent('click_b2b')
    }
  }
}
